import { Input as InputComp } from './Input';
import { InputGroup } from './InputGroup';
export var Input = Object.assign(InputComp, {
  Group: InputGroup
});